import {
  createGlobalSpinnerHelpers,
  createLayoutActionHooks,
  createLayoutStore,
  type LayoutState
} from '@dec/shared/utils/layoutStore';

export type { LayoutState };

export const useLayoutStore = createLayoutStore();

export const { useLayoutActions, useSpinnerActions } = createLayoutActionHooks(useLayoutStore);

export const { showGlobalSpinner, hideGlobalSpinner } = createGlobalSpinnerHelpers(useLayoutStore);
